// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Hk7O","footer":"ModalFilter_footer__2qlQ_"};